import React from "react";
import { Grid } from "@mui/material";
// import { plants } from "../../libs/plants";
import PlantListItem from "./ListItem";
// import PlantListItem from "../Designer/Plant/ListItem";

const PlantList = ({ plants, searchTerm }) => {
  let filteredPlants = plants;
  if (searchTerm) {
    filteredPlants = plants.filter((plant) => {
      return plant.name.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }
  return (
    <Grid container spacing={2}>
      {filteredPlants.map((plant, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <PlantListItem plant={plant} />
        </Grid>
      ))}
    </Grid>
  );
};

export default PlantList;
